module.exports = __webpack_public_path__ + "static/media/A Shot in the Dark.1254d7eb.jpg";